<div class="row h-100">
  <div class="container-fluid">
    <div class="lg_wrapper">
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mx-auto">
        <div class="">
          <div class="brand mb-4 text-center">
            <img src="assets/logo.svg"  class="img-fluid" />
          </div>
        </div>
        <form class="form-signin" [formGroup]="loginForm" autocomplete="off">
          <div class="form-label-group">
            <input type="text" name="fakeusernameremembered" formControlName="userName" id="userName" class="form-control"
              placeholder="User ID" autocomplete="new-username"/>
            <label for="userName">User ID</label>
          </div>
          <div class="form-label-group">
            <input type="text" name="fakepasswordremembered"  formControlName="password" class="form-control" id="password" (input)="changeType()" (change)="changeType()"
              placeholder="Password" autocomplete="off" />
            <label for="password">Password</label>
          </div>
          <div class="form-label-group">
            <input *ngIf="hmacEnabled" name="secret_key" formControlName="secret_key" type="text" id="secret_key"
              class="form-control" placeholder="Secret Key" required autocomplete="off" />
            <label for="secret_key">Secret Key</label>
          </div>
          <div class="form-label-group">
            <input *ngIf="hmacEnabled" type="text" placeholder="User key" name="user_key" formControlName="user_key"
              id="user_key" class="form-control" required name="fakeuserkeyremmebered" autocomplete="off"/>
            <label for="user_key">User Key</label>
          </div>
          <div class="alert alert-danger" #hideDiv *ngIf="errorMessage" (click)="FocusEvent()">
            {{errorMessage}}
          </div>
          <button class="btn btn-primary" type="button" (click)="Login()" [disabled]="!loginForm.valid">
            <ngx-bootstrap-spinner name="loginSpinner" bdColor = "rgba(0, 0, 0, 0.8)" size = "small" color = "#d91d1d" type = "border" isButtonSpinner = "true" autoDisableButton = "true" loadingText = "">
            </ngx-bootstrap-spinner>
            Sign in
          </button>
          <p class="mt-5 mb-3 text-muted">
            &copy; {{ copyRightYear }} Love For Data All Rights Reserved.
          </p>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="d-none">
  <div class="body"></div>
  <div class="grad"></div>
  <div class="header">
    <div>Boiler <span>Plate</span></div>
  </div>
  <br />
  <form class="login" [formGroup]="loginForm">
    <input type="text" placeholder="Enter Username / Email" name="userName" formControlName="userName" />
    <br />
    <input type="password" placeholder="Enter Password" name="password" formControlName="password" />
    <br *ngIf="hmacEnabled" />
    <br *ngIf="hmacEnabled" />
    <input *ngIf="hmacEnabled" type="text" placeholder="Enter Secret Key" name="secret_key"
      formControlName="secret_key" />
    <br *ngIf="hmacEnabled" />
    <br *ngIf="hmacEnabled" />

    <input *ngIf="hmacEnabled" type="text" placeholder="Enter User key" name="user_key" formControlName="user_key" />
    <br />
    <p><i style="color: white">Note: No whitespace allowed</i></p>
    <button type="button" [disabled]="!loginForm.valid || ValidateKeys()" (click)="Login()">
      Login
    </button>
    <br /><br /><br /><br /><br />
    <div>
      <span style="color: white">© {{ copyRightYear }} Love For Data All Rights Reserved.</span>
    </div>
  </form>

  <br />
</div>